<template>
	<div class="userdetail">
		<div class="userView">
			<div class="userdetail_title">
				<p>个人信息</p>
				<span @click="changeInfo">编辑</span>
			</div>
			<div class="userdetail_head" v-show="changeShow">
				<p>{{user.username}}</p>
				<p>
					<span>手机号：{{user.cellphone}}</span><span>邮箱：{{user.email}}</span>
				</p>
				<p class="">
					<span>出生日期：{{user.birth}}</span><span>单位：{{user.company}}</span>
				</p>
				<p>
					<span>职务：{{user.post}}</span>
				</p>
			</div>
			<!-- 编辑 -->
			<div class="userdetail_head" v-if="!changeShow">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<div class="userdetail_head_form">
						<el-form-item label="姓名" prop="username">
							<el-input v-model="ruleForm.username"></el-input>
						</el-form-item>

						<el-form-item label="邮箱" prop="email">
							<el-input v-model="ruleForm.email"></el-input>
						</el-form-item>

						<el-form-item label="出生日期" prop="birthdate">
							<el-date-picker
									v-model="ruleForm.birth"
									type="date"
									style="width: 150px;"
									placeholder="选择日期"
									format="yyyy-MM-dd" value-format="yyyy-MM-dd"
							>
							</el-date-picker>
						</el-form-item>

					</div>
					<div class="userdetail_head_form">
						<el-form-item label="单位" prop="company">
							<el-input v-model="ruleForm.company"></el-input>
						</el-form-item>

						<el-form-item label="职务" prop="post">
							<el-input v-model="ruleForm.post"></el-input>
						</el-form-item>
					</div>


					<el-form-item label="头像" prop="name">
						<!--<el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
							:show-file-list="false" :on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload">
							<img v-if="imageUrl" :src="imageUrl" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon">
							</i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
						</el-upload>-->

						<el-upload
								class="upload-demo"
								action=""
								:before-upload="beforeAvatarUpload"
								:http-request="httpRequest2"
								:on-remove="handleRemove2"
								:on-exceed="handleExceed"
								:file-list="pictureFileList2"
								list-type="picture"
								:limit='1'>
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
						</el-upload>

					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
						<el-button @click="resetForm('ruleForm')">重置</el-button>
						<el-button @click="changeShow = true">取消</el-button>
					</el-form-item>
				</el-form>

			</div>
		</div>
	</div>
</template>

<script>

	import {getUserInfo ,editUserInfo} from "../../api/moudles/user";

	import {client} from "../../libs/alioss";

	const ossPath = localStorage.getItem('ossPath');

	export default {
		components: {

		},

		created() {

			this.fetchData()
		},
		data() {
			return {

				user:[],
				pictureFileList2:[],
				changeShow: true,
				imageUrl: '',
				url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				srcList: [
					'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
					'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
				],
				ruleForm: {
					username: '',
					email: '',
					birth: '',
					company: '',
					post: '',
					head_img_url: ''
				},
				rules: {
					username: [
							{
							required: true,
							message: '请输入真实姓名',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 5,
							message: '长度在 2 到 10 个字符',
							trigger: 'blur'
						}
					],


				},
			}
		},
		methods: {


			fetchData(){

				let token = localStorage.getItem('userToken')

				let that  = this

				getUserInfo({
					data: {
						token:token,
					},
					success: (res) => {

						console.log(res)

						if(res.code == -1){

							this.$message.error("登录状态失效，请重新登录");

							setTimeout(function () {

								//localStorage.clear()
								localStorage.removeItem('userToken')
								localStorage.removeItem('userName')
								localStorage.removeItem('userAvatar')

								that.$bus.$emit('brotherEvent', 'login')
								that.$router.push('/login')

							},1000)
						}

						this.user = res.data
					}
				})
			},

			addCert() {
				this.$refs.addDialog.openDialog()
			},
			changeInfo() {
				this.changeShow = false
				this.ruleForm = this.user
			},
			handleAvatarSuccess(res, file) {

				this.imageUrl = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isLt10M = file.size / 1024 /1024  < 10;
				if (['image/png', 'image/jpg','image/jpeg'].indexOf(file.type) == -1) {
					this.$message.error('请上传正确的图片格式');
					return false;
				}
				if (!isLt10M) {
					this.$message.error('上传图片大小不能超过10MB哦!');
					return false;
				}
			},

			httpRequest2({ file }){//阿里云OSS上传
				const fileName = ossPath + `/官网/直播/${Date.parse(new Date())}/${file.name}`;  //定义唯一的文件名
				// console.log(fileName)

				this.pictureFileList2 = []

				client.put(fileName, file).then( ({res, url, name}) => {
					if (res && res.status == 200) {

						this.ruleForm.head_img_url = url
						console.log(`阿里云OSS上传文件成功回调`, res, url, name);
						this.pictureFileList2.push({//回显文件name用
							url:url,
							id:fileName,
							name:file.name,
						})
					}
				}).catch((err) => {
					console.log(`阿里云OSS上传失败回调`, err);
				});
			},

			//移除图片
			handleRemove2() {
				this.pictureFileList2 = [];
				this.ruleForm.head_img_url = '';
			},
			//超出文件设置
			handleExceed(){
				this.$message({
					message: '只能上传一个文件，如需更换，请删除原有文件',
					type: 'warning'
				});
			},


			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {

						let token = localStorage.getItem('userToken')

						editUserInfo({
							data: {
								token:token,
								form:this.ruleForm
							},
							success: (res) => {

								console.log(res)

								if(res.code == 200){

									localStorage.setItem('userName',res.data.username)
									localStorage.setItem('userAvatar',res.data.head_img_url)

									location.reload()
								}else{
									this.$message({
										message: '上传失败',
										type: 'error'
									});
								}

							}
						})


					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style scoped>

	/**滚动条的宽度*/
	::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	/*滚动条的滑块*/
	::-webkit-scrollbar-thumb {
		background-color: rgb(185, 221, 255);
		border-radius: 5px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: rgba(24,144,255,.8);
	}

	.userView {
		min-height: 200px;
		background-color: #fff;
		margin-bottom: 20px;
	}

	.userdetail_title {
		display: flex;
		justify-content: space-between;
		height: 60px;
		font-weight: 500;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #f2f2f2;
	}

	.userdetail_title p {
		font-size: 22px;
	}

	.userdetail_title span {
		cursor: pointer;
	}

	.userdetail_head {
		padding: 20px;
	}

	.userdetail_head p {
		margin: 10px 0;
	}

	.userdetail_head p>span {
		display: inline-block;
		width: 30%;
		margin-right: 2%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.userdetail_head_form {
		width: 100%;
		display: flex;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
		border: 1px solid #DCDFE6;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.userdetail_body {
		display: flex;
		padding: 20px;
	}

	.userdetail_body__view {
		width: 30%;
		margin-right: 2%;
	}
</style>
